<template>
	<v-row>
		<v-col>
			<v-tabs fixed-tabs>
				<v-tab>Fotka</v-tab>
				<v-tab>Heslo</v-tab>
				<v-tab>Popis</v-tab>

				<v-tab-item>
					<profile-pic />
				</v-tab-item>
				<v-tab-item>
					<password />
				</v-tab-item>
				<v-tab-item>
					<description />
				</v-tab-item>
			</v-tabs>
		</v-col>
	</v-row>
</template>

<script>
import ProfilePic from './components/profilePic'
import Password from './components/password'
import Description from './components/description'
export default {
	name: 'Settings',
	components: { ProfilePic, Password, Description }
}
</script>
